<!-- eslint-disable vue/html-self-closing -->
<template>
    <div>
        <v-card flat tile>
            <v-app-bar dense color="#F3F4F6" style="border-bottom: 1px solid #D2D6DB; position:fixed; width:100%; z-index:1000" hide-on-scroll>
                <v-toolbar-title class="d-flex justify-space-between flex-column flex-sm-row" style="width: 100%;">
                    <ul class="top-header-menu m-0 d-none d-sm-block">
                        <li><a class="dropdown-item" target="_blank" href="https://balady.gov.sa">{{$t('Baladi')}}</a></li>
                        <li class="dot"></li>
                        <li><a class="dropdown-item" href="https://sakani.sa" target="_blank">{{$t('Sakani')}}</a></li>
                        <li class="dot"></li>
                        <li><a class="dropdown-item" :href="`https://momah.gov.sa/${language}/branches`" target="_blank">{{$t('Municipalities')}}</a></li>
                    </ul>
                    <div>
                    <v-menu tile left bottom rounded offset-y transition="scale-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn class="me-2" elevation="0" v-on="on">
                                <v-badge :content="messages"
                                        :value="messages"
                                        
                                        overlap :style="messages>0?'margin-top:5px':''">
                                    <v-icon color="#384250">
                                        mdi-bell
                                    </v-icon>
                                </v-badge>
                            </v-btn>
                        </template>
                        <v-card tile width="300" v-if="messages > 0">
                            <v-card-title class="primary--text"><h5>{{ $t('Notifications') }}</h5></v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <h4>{{ $t('Having') }} {{ $t('Count') }} <v-chip color="primary" x-small label>{{messages }}</v-chip> {{ $t('InboxText') }}</h4>
                            </v-card-text>
                        </v-card>
                    </v-menu>
                    <v-menu tile rounded="0" offset-y>
                        <template #activator="{ attrs, on }">
                            <v-btn elevation="0" :loading="changingLanguage" v-bind="attrs" v-on="on" class="me-2">
                                <v-icon color="#384250">
                                    mdi-earth
                                </v-icon>
                                {{ isArabicLanguage ? 'العربية' : 'English' }}
                            </v-btn>
                        </template>

                        <v-list tile dense color="grey lighten-4" class="pb-0">
                            <template v-if="isArabicLanguage">
                                <v-list-item @click="changeLanguage('en')">
                                    <v-list-item-title>
                                        <h4>
                                            English
                                        </h4>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider />
                            </template>
                            <template v-else>
                                <v-list-item @click="changeLanguage('ar')">
                                    <v-list-item-title>
                                        <h4>
                                            العربية
                                        </h4>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider />
                            </template>
                        </v-list>
                    </v-menu>

                    <v-menu tile rounded="0" offset-y>
                        <template #activator="{ attrs, on }">
                            <v-btn elevation="0" v-bind="attrs" v-on="on" class="me-2">
                                <v-icon color="#384250">
                                    mdi-account-circle
                                </v-icon>
                            </v-btn>
                        </template>

                        <v-list tile color="grey lighten-4" class="pb-0">
                            <v-list-item class="pb-4">
                                <v-list-item-avatar>
                                    <v-avatar color="primary" size="56">
                                        <v-icon dark>
                                            mdi-account-circle
                                        </v-icon>
                                    </v-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <h3>{{ isArabicLanguage ? loggedInUser?.fullnameAr : loggedInUser?.fullnameEn }}</h3>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ loggedInUser?.email }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider />

                            <v-list-item link @click="showPasswordDialog = true">
                                <v-list-item-title>
                                    <h4>
                                        <v-icon dense color="dark">
                                            mdi-lock
                                        </v-icon>
                                        {{ $t("ChangePassword") }}
                                    </h4>
                                </v-list-item-title>
                            </v-list-item>
                            <v-divider />
                            <v-list-item link @click="showSignatureDialog = true">
                                <v-list-item-title>
                                    <h4>
                                        <v-icon dense color="dark">mdi-account-edit</v-icon>
                                        {{ $t("EditSignature") }}
                                    </h4>
                                </v-list-item-title>
                            </v-list-item>
                            <v-divider />
                            <v-list-item link @click="downloadGuide">
                                <v-list-item-title>
                                    <h4>
                                        <v-icon dense color="dark">
                                            mdi-book-open-page-variant
                                        </v-icon>
                                        {{ $t("UserGuide") }}
                                    </h4>
                                </v-list-item-title>
                            </v-list-item>
                            <v-divider />
                            <v-list-item link @click="logout()">
                                <v-list-item-title>
                                    <h4>
                                        <v-icon dense color="dark">
                                            mdi-power
                                        </v-icon>
                                        {{ $t("SignOut") }}
                                    </h4>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                </v-toolbar-title>
            </v-app-bar>
            <v-app-bar v-if="!scrolled" elevation="0" height="auto" dense color="#FFF" style="position:fixed; width:100%; z-index:1000; top:48px ;border-bottom: 1px solid #D2D6DB;padding:0px" hide-on-scroll>
                <v-container fluid style="padding-left:0px;padding-right:0px">
                    <v-row>
                        <!-- Burger Menu for Mobile -->
                        <v-col cols="5" class="text-start d-block d-lg-none">
                            <v-app-bar-nav-icon color="black" @click="drawer = !drawer" />
                        </v-col>

                        <!-- Logo -->
                        <v-col cols="auto" class="text-end d-flex d-lg-block justify-end" style="padding:10px 5px">
                            <v-btn text to="/" class="logolink" :style="`float:${ language == 'ar'?'right':'left' };display:inline; padding:0px;background-color:transparent !important`"><img style="height:40px;" src="../../assets/images/mh-logo-full.png" /></v-btn>
                        </v-col>
                        
                        <!-- Navigation Links (Visible on larger screens) -->
                        <v-col cols="auto" class="d-none d-lg-flex pa-0">
                            <v-row justify="center" no-gutters>
                                <template v-for="item in menus">
                                    <v-btn v-if="item.route" :key="item.id" :to="{ name: item.route }" text class="mx-2 menubtn py-7">
                                        {{ $t(item.title) }}
                                    </v-btn>

                                    <v-menu v-else :key="item.id" offset-y close-on-content-click>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" text class="mx-2 menubtn py-7">
                                                {{ $t(item.title) }}
                                                <v-icon right>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>

                                        <!-- Dropdown Menu Items -->
                                        <v-list>
                                            <v-list-item v-for="child in item.children"
                                                         :key="child.id"
                                                         :to="{ name: child.route }"
                                                         class="px-4">
                                                <v-icon size="15" color="primary" class="mr-2">
                                                    {{ isArabicLanguage ? 'mdi-subdirectory-arrow-left' : 'mdi-subdirectory-arrow-right' }}
                                                </v-icon>
                                                <v-list-item-content>
                                                    <span class="node-item-sub">{{ $t(child.title) }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-row>
                        </v-col>

                        <!-- Additional Logo -->
                       
                    </v-row>
                </v-container>
            </v-app-bar>
        </v-card>
        <v-app-bar v-if="scrolled" dense tile app height="auto" color="#ffffff" style="z-index:99999">
            <v-container fluid style="padding-left:0px;padding-right:0px">
                    <v-row>
                        <!-- Burger Menu for Mobile -->
                        <v-col cols="5" class="text-start d-block d-lg-none">
                            <v-app-bar-nav-icon color="black" @click="drawer = !drawer" />
                        </v-col>

                        <!-- Logo -->
                        <v-col cols="auto" class="text-end d-flex d-lg-block justify-end" style="padding:10px 5px">
                            <v-btn text to="/" class="logolink" :style="`float:${ language == 'ar'?'right':'left' };display:inline; padding:0px;background-color:transparent !important`"><img style="height:40px;" src="../../assets/images/mh-logo-full.png" /></v-btn>
                        </v-col>
                        
                        <!-- Navigation Links (Visible on larger screens) -->
                        <v-col cols="auto" class="d-none d-lg-flex pa-0">
                            <v-row justify="center" no-gutters>
                                <template v-for="item in menus">
                                    <v-btn v-if="item.route" :key="item.id" :to="{ name: item.route }" text class="mx-2 menubtn py-7">
                                        {{ $t(item.title) }}
                                    </v-btn>

                                    <v-menu v-else :key="item.id" offset-y close-on-content-click>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" text class="mx-2 menubtn py-7">
                                                {{ $t(item.title) }}
                                                <v-icon right>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>

                                        <!-- Dropdown Menu Items -->
                                        <v-list>
                                            <v-list-item v-for="child in item.children"
                                                         :key="child.id"
                                                         :to="{ name: child.route }"
                                                         class="px-4">
                                                <v-icon size="15" color="primary" class="mr-2">
                                                    {{ isArabicLanguage ? 'mdi-subdirectory-arrow-left' : 'mdi-subdirectory-arrow-right' }}
                                                </v-icon>
                                                <v-list-item-content>
                                                    <span class="node-item-sub">{{ $t(child.title) }}</span>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-row>
                        </v-col>

                        <!-- Additional Logo -->
                       
                    </v-row>
                </v-container>
        </v-app-bar>
        
        <!-- Sidebar Navigation Drawer -->
        <v-navigation-drawer app v-model="drawer" temporary style="z-index:99999999"
                             :right="isArabicLanguage ? true : false">
            <v-list-item class="px-2">
                <v-list-item-avatar>
                    <v-img small :src="require('@/assets/images/balady.png')" class="pa-md-4 mx-lg-auto" width="35%" alt />
                </v-list-item-avatar>

                <v-list-item-title>{{ $t("ApplicationName") }}</v-list-item-title>

                <v-btn icon
                       @click.stop="drawer = !drawer">
                    <v-icon v-if="!isArabicLanguage">mdi-chevron-left</v-icon>
                    <v-icon v-else>mdi-chevron-right</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider></v-divider>


            <v-list dense>
                <template v-for="item in menus">

                    <v-list-item v-if="item.route" :key="item.id" :to="{ name: item.route }">
                        <v-list-item-icon>
                            <v-icon> {{ item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <span class="node-item"> {{ $t(item.title) }}</span>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group v-if="!item.route" :key="item.id" no-action color="secondary" active-class="secondary--text">
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content v-if="item.route">
                                <b class="text-decoration-none node-item" :to="{ name: item.route }">{{ $t(item.title) }}</b>
                            </v-list-item-content>
                            <v-list-item-content v-else>
                                <span class="node-item">{{ $t(item.title) }}</span>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="child in item.children" :key="child.id" :to="{ name: child.route }">
                            <v-icon size="15" color="primary" v-if="isArabicLanguage">mdi-subdirectory-arrow-left</v-icon>
                            <v-icon size="15" color="primary" v-else>mdi-subdirectory-arrow-right</v-icon>
                            <v-list-item-content>
                                <span class="node-item-sub">{{ $t(child.title) }}</span>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>
        <!--<v-app-bar dense tile app dark color="primary">
        <v-app-bar-nav-icon @click.stop="$emit('sidebarToggled', false)"></v-app-bar-nav-icon>

        <router-link to="/" class="white--text text-decoration-none"><v-icon>mdi-home</v-icon> <span class="hometitle">{{ $t('Home') }}</span></router-link>
        <v-spacer class="homespacer" />
        <v-menu tile left bottom rounded offset-y transition="scale-transition">
            <template v-slot:activator="{ on }">
                <v-btn small v-on="on" color="primary" elevation="0">
                    <v-badge :content="messages"
                             :value="messages"
                             color="secondary"
                             overlap>
                        <v-icon>
                            mdi-bell
                        </v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-card tile width="300" v-if="messages > 0">
                <v-card-title class="primary--text"><h5>{{ $t('Notifications') }}</h5></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <h4>{{ $t('Having') }} {{ $t('Count') }} <v-chip color="primary" x-small label>{{messages }}</v-chip> {{ $t('InboxText') }}</h4>
                </v-card-text>

            </v-card>
        </v-menu>
        <v-menu tile rounded="0" offset-y>
            <template #activator="{ attrs, on }">
                <v-btn elevation="0" tile color="primary" dark :loading="changingLanguage" v-bind="attrs" v-on="on">
                    <v-icon>
                        mdi-earth
                    </v-icon>
                    {{ isArabicLanguage ? 'العربية' : 'English' }}
                </v-btn>
            </template>

            <v-list tile dense color="grey lighten-4" class="pb-0">
                <template v-if="isArabicLanguage">
                    <v-list-item @click="changeLanguage('en')">
                        <v-list-item-title>
                            <h4>
                                English
                            </h4>
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider />
                </template>
                <template v-else>
                    <v-list-item @click="changeLanguage('ar')">
                        <v-list-item-title>
                            <h4>
                                العربية
                            </h4>
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider />
                </template>
            </v-list>
        </v-menu>

        <v-menu tile rounded="0" offset-y>
            <template #activator="{ attrs, on }">
                <v-btn elevation="0" tile color="primary" v-bind="attrs" v-on="on">
                    <v-icon large>
                        mdi-account-circle
                    </v-icon>
                </v-btn>
            </template>

            <v-list tile color="grey lighten-4" class="pb-0">
                <v-list-item class="pb-4">
                    <v-list-item-avatar>
                        <v-avatar color="primary" size="56">
                            <v-icon dark>
                                mdi-account-circle
                            </v-icon>
                        </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            <h3>{{ isArabicLanguage ? loggedInUser?.fullnameAr : loggedInUser?.fullnameEn }}</h3>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ loggedInUser?.email }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider />

                <v-list-item link @click="showPasswordDialog = true">
                    <v-list-item-title>
                        <h4>
                            <v-icon dense color="dark">
                                mdi-lock
                            </v-icon>
                            {{ $t("ChangePassword") }}
                        </h4>
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
    <v-list-item link @click="showSignatureDialog = true">
        <v-list-item-title>
            <h4>
                <v-icon dense color="dark">mdi-account-edit</v-icon>
                {{ $t("EditSignature") }}
            </h4>
        </v-list-item-title>
    </v-list-item>
    <v-divider />
                <v-list-item link @click="downloadGuide">
                    <v-list-item-title>
                        <h4>
                            <v-icon dense color="dark">
                                mdi-book-open-page-variant
                            </v-icon>
                            {{ $t("UserGuide") }}
                        </h4>
                    </v-list-item-title>
                </v-list-item>
                <v-divider />
                <v-list-item link @click="logout()">
                    <v-list-item-title>
                        <h4>
                            <v-icon dense color="dark">
                                mdi-power
                            </v-icon>
                            {{ $t("SignOut") }}
                        </h4>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>


    </v-app-bar>-->

        <user-signature v-if="showSignatureDialog" v-model="showSignatureDialog" />
        <user-password v-if="showPasswordDialog" v-model="showPasswordDialog" />
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { clearTranslation } from '@/plugins/i18n/index.js'
    import { connection } from '@/plugins/hub/myHubPlugin.js'
    import UsersService from '@/services/UsersService.js'

    import AttachmentsService from '@/services/AttachmentsService'
    import UserSignature from '@/components/app/user/UserSignature.vue'
    import UserPassword from '@/components/app/user/UserPassword.vue'
    import { openFile } from '@/helpers/downloader.js'

    import getMenus from '@/plugins/router/menus/menus.js'
    export default {

        components: {
            UserSignature, UserPassword
        },

        data() {
            return {
                messages: 0,
                changingLanguage: false,
                showSignatureDialog: false,
                showPasswordDialog: false,
                scrolled: false,
                menus: [],
                drawer: false,
            }
        },

        created() {
            if (this.loggedInUser) {
                this.loadNotifications()
            }
        },

        computed: {
            ...mapGetters('user', ['loggedInUser', 'language']),

            isArabicLanguage() {
                return this.language == 'ar'
            }
        },

        mounted() {
            UsersService.listCurrentUserPermissions().then((res) => {
                if (res.data) {
                    this.filterMenu(res.data)
                }
            }).catch(() => {
                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
            }).finally(() => {
                this.loading = false
            })
            this.currentLanguage = this.language

            connection.on('ReceiveChanges', () => {
                this.messages = this.messages + 1
            })

            connection.on('ReceiveClaim', () => {
                this.messages = this.messages - 1
            })
            window.addEventListener('scroll', this.onScroll)
        },

        methods: {
            filterMenu(menuItems) {
                let menuList = getMenus()
                let rootElements = menuList.filter(x => x.children == null)
                let nodeElements = menuList.filter(x => x.children != null)

                for (var i = 0; i < menuItems.length; i++) {
                    let currentItem = menuItems[i]
                    if (currentItem.hasAccess) {
                        let menuItem = rootElements.filter(r => r.id == currentItem.name)[0]
                        if (menuItem) {
                            this.menus.push(menuItem)
                        }
                    }
                }

                for (var j = 0; j < nodeElements.length; j++) {
                    let nodeElement = nodeElements[j]
                    let childsArray = []
                    if (nodeElement) {
                        for (var k = 0; k < nodeElement.children.length; k++) {
                            let childElement = nodeElement.children[k]
                            if (menuItems.filter(x => x.name == childElement.id).length > 0) {
                                childsArray.push(childElement)
                            }
                        }
                        if (childsArray.length > 0) {
                            nodeElement.children = childsArray
                            this.menus.push(nodeElement)
                        }
                    }
                }
            },
            onScroll() {
                // Check scroll position and toggle app bars
                this.scrolled = window.scrollY > 50 // Adjust threshold as needed
            },
            changeLanguage(language) {

                clearTranslation()

                this.changingLanguage = true
                UsersService.changeLanguage(language).then((res) => {

                    this.$store.dispatch('user/setUserSession', res.data)
                    this.$store.dispatch('user/setLanguage', language)
                    window.location.href = '/'

                }).catch(() => {

                }).finally(() => {
                    this.changingLanguage = false
                })
            },

            downloadGuide() {
                AttachmentsService.getUserGuide().then((res) => {
                    openFile(res.data)
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },

            loadNotifications() {
                UsersService.countUnclaimedTasks().then(res => {
                    if (res.data) {
                        this.messages = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            logout() {
                this.$router.push({ name: 'logout' })
            }
        }
    }
</script>
<style>
    ul.top-header-menu * {
        color: #dedede;
    }
    ul.top-header-menu li {
        display: inline-block;
        padding:0 15px
    }

    li.dot {
        width: 6px;
        height: 6px;
        background: #ffffff54;
        border-radius: 50px !important;
        padding:0px !important
    }

    ul.top-header-menu li .dropdown-item {
        display: block;
        width: 100%;
        padding: 5px;
        color:#384250;
        font-weight: 400;
        font-size: .85rem;
        text-align: inherit;
        white-space: nowrap;
        text-decoration: none;
    }
    ul.top-header-menu li:first-child .dropdown-item {
        padding: 5px;
        background: #7fbe41;
        border-radius: 6px !important;
    }
    .v-btn.menubtn{
        font-size: 0.65vw !important;
        padding:0px !important;
        font-weight: 600;
        height: 45px!important;
    }
    .logolink{
        height:auto
    }
    .logolink::before, .logolink:hover::before{
        opacity:0 !important
    }
    .v-btn.menubtn:not(.v-btn--round).v-size--default {
        position: relative;
        height: 100%!important;
    }
    .v-btn--active.menubtn::after {
        content: "";
        height: 7px;
        border-radius: 20px;
        width: 80%;
        
        bottom: 0;
        background-color: #54C08A;
        position: absolute;
        z-index: 9999;

    }
    .v-btn.menubtn:before {
        background-color: #1B8354!important;
    }
    .theme--light.v-btn--active.logolink::before, .theme--light.v-btn--active.logolink:hover::before {
        opacity: 0!important;
    }
    .v-ripple__container {
        background-color: transparent;
    }
    .theme--light.v-btn:focus::before, .theme--light.v-btn:hover::before, .theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
        opacity: 1!important;
    }
    .v-btn__content {
        padding: 0 5px;
    }
 
    .theme--light.v-btn:focus .v-btn__content, .theme--light.v-btn:hover .v-btn__content, .theme--light.v-btn--active:hover .v-btn__content, .theme--light.v-btn--active .v-btn__content {
        color: #FFF;
    }
    .v-btn--active.logolink:before, .v-btn.logolink:before {
background-color: transparent!important;
    }
    
</style>